/**
 * Normalizes GET .../reports/products?view=full (and similar) response bodies.
 * The axios layer returns response.data already.
 */
const emptyProductList = () => ({
  data: [],
  total: 0,
  per_page: 10,
  current_page: 1,
});

/**
 * @param {Record<string, unknown>} body - API JSON body
 * @returns {{ topLines: any[], categoryBreakdown: any[], productList: { data: any[], total: number, per_page: number, current_page: number } }}
 */
export function normalizeProductsReportFullPayload(body) {
  if (!body || typeof body !== 'object') {
    return {
      topLines: [],
      categoryBreakdown: [],
      productList: emptyProductList(),
    };
  }

  const nested =
    body.data &&
    typeof body.data === 'object' &&
    !Array.isArray(body.data) &&
    (Object.prototype.hasOwnProperty.call(body.data, 'topLines') ||
      Object.prototype.hasOwnProperty.call(body.data, 'top_lines') ||
      Object.prototype.hasOwnProperty.call(body.data, 'table') ||
      Object.prototype.hasOwnProperty.call(body.data, 'categoryBreakdown'));

  const root = nested ? body.data : body;

  const topLines = root.topLines ?? root.top_lines ?? [];
  const categoryBreakdown =
    root.categoryBreakdown ?? root.category_breakdown ?? [];

  const table = root.table ?? {};
  const tableRows = table.data;
  let rows = Array.isArray(tableRows) ? tableRows : [];
  if (!rows.length && Array.isArray(root.data) && !root.table) {
    rows = root.data;
  }

  const pag =
    table.pagination ||
    table.meta ||
    (table && typeof table === 'object' && table.total != null ? table : {}) ||
    {};

  const productList = {
    data: rows,
    total:
      Number(pag.total ?? table.total ?? root.total ?? 0) ||
      (Array.isArray(rows) ? rows.length : 0),
    per_page: Number(pag.per_page ?? pag.perPage ?? root.per_page ?? 10) || 10,
    current_page:
      Number(pag.current_page ?? pag.currentPage ?? root.current_page ?? 1) ||
      1,
  };

  return {
    topLines: Array.isArray(topLines) ? topLines : [],
    categoryBreakdown: Array.isArray(categoryBreakdown) ? categoryBreakdown : [],
    productList,
  };
}
